import './keywords_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.PostKeywordFilterView extends Monitoring.Views.SocialContents.Filters.KeywordsFilterView

  withPrefix: (search_query_field) ->
    "post_#{search_query_field}"
